import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const BASE_URL = environment.userAuthApiUrl;

export const userAuthFetcher = <T>(
    config: {
        url: string;
        method: string;
        data?: any;
        headers?: Record<string, string>;
        params?: Record<string, any>;
    },
    http: HttpClient,
    options?: any
): Observable<T> => {
    return http.request<T>(config.method, `${BASE_URL}${config.url}`, {
        body: config.data,
        headers: config.headers,
        params: config.params,
        observe: 'body',
        responseType: 'json',
        ...options
    }) as Observable<T>;
};